require('../../../../_lib/jquery.passwordRequirements');

$('body').tooltip({
  selector: '[data-toggle="tooltip"]'
});

$(() => {
  let isEdit = false;
  const country = $('#accountDetail .select-country').val();
  const menuController = Router.getController('customer.account.menuController');
  menuController.initialize();

  // Report pdf table
  const reportTable = $('#report-pdf-table').DataTable({
    processing: true,
    serverSide: true,
    ajax: urlPdfReportData,
    order: [[1, 'asc']],
    pageLength: 5,
    recordsFiltered: 5,
    bFilter: true,
    lengthChange: false,
    searching: false,
    info: false,
    pagingType: 'simple',
    autoWidth: false,
    columns: [
      { name: 'type' },
      { name: 'date_create', class: 'text-nowrap' },
      { name: 'status', class: 'text-right text-nowrap' }
    ]
  });

  if (typeof urlDownloadsData !== 'undefined') {
    // Report pdf table
    var downloadsTable = $('#downloads-table').DataTable({
      processing: true,
      serverSide: true,
      ajax: urlDownloadsData,
      order: [[1, 'asc']],
      pageLength: 5,
      recordsFiltered: 5,
      bFilter: true,
      lengthChange: false,
      searching: false,
      info: false,
      pagingType: 'simple',
      autoWidth: false,
      columns: [
        { name: 'id_list' },
        { name: 'date_create', class: 'text-nowrap' },
        { name: 'status', class: 'text-right text-nowrap' }
      ]
    });
  }

  setInterval(() => {
    if (menuController.getCurrentTab() === 'downloads') {
      if (downloadsTable) {
        downloadsTable.ajax.reload(null, false);
      }

      if (reportTable) {
        reportTable.ajax.reload(null, false);
      }
    }
  }, 5000);

  changeState('#accountDetail', country);

  $('.pr-password').passwordRequirements();

  $('#accountDetail .select-country').select2({
    placeholder: 'Select Country'
  });

  $('#accountDetail .select-country').on('change', (e) => {
    const country = $('#accountDetail .select-country').val();
    changeState('#accountDetail', country);
  });

  $('#form-organization .select-country').on('change', (e) => {
    const country = $('#form-organization .select-country').val();
    changeState('#form-organization', country);
  });

  $('#accountDetail .select-denomination').select2({
    placeholder: 'Select Denomination'
  });

  $('#accountDetail .select-state').select2({
    placeholder: 'Select State'
  });

  $('#accountDetail select[name="timezone"]').select2({
    placeholder: 'Select Timezone'
  });

  $('#accountDetail .select2-container').on('keypress', function (e) {
    $(this).prev().select2('open');
  });

  $('#form-organization .select-country').select2({
    placeholder: 'Select Country',
    width: '100%'
  });

  $('#form-organization .select-denomination').select2({
    placeholder: 'Select Denomination',
    width: '100%'
  });

  $('#form-organization .select-state').select2({
    placeholder: 'Select State',
    width: '100%'
  });

  $('#editGroupUser .select-user').select2({
    placeholder: 'Select User',
    width: '100%',
    minimumResultsForSearch: -1
  });

  $('.category').editable({
    emptytext: 'Current Category',
    success(res) {
      if (res.isError == 1) toastr.error(res.msgError, 'Error');
      else toastr.success('Organization has been saved.', 'Success');
    }
  });

  const original = $.fn.editableutils.setCursorPosition;
  $.fn.editableutils.setCursorPosition = function () {
    try {
      original.apply(this, Array.prototype.slice.call(arguments));
    } catch (e) { /* noop */ }
  };

  const form = $('#form-organization');
  $('#add-organization-btn').click(() => {
    isEdit = false;

    form.find('.help-block').remove();
    form.find('#add-organization div').removeClass('has-error');

    form.find('#primary-user-row').show();
    form.find('#primary-user-row').show();
  });

  $('a#edit-organization-btn').click(() => {
    isEdit = true;

    form.find('.help-block').remove();
    form.find('#add-organization div').removeClass('has-error');

    form.find('#primary-user-row').hide();
    form.find('#primary-user-row').hide();
  });

  $('#addOrganizationBtn').click(() => {
    $('#add-organization .modal-footer button').hide();
    $('#add-organization .modal-footer img').show();

    $('.help-block').remove();
    $('#add-organization div').removeClass('has-error');

    const idOrganization = $('#add-organization #addOrganizationBtn').data('id');
    const dataArr = $('#form-organization').serializeArray();

    $.post(saveOrganizationUrl, {
      dataArr,
      idOrganization,
      addLicense: false,
      groupId,
      edit: isEdit
    }, (data, b) => {
      $('#add-organization .modal-footer button').show();
      $('#add-organization .modal-footer img').hide();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');

        if (data.errors && data.errors.length !== 0) {
          $.each(data.errors, (elementId, value) => {
            $.each(value, (index, value) => {
              $('#form-organization').find(`[name="${elementId}"]`).parent().addClass('has-error');
              $('#form-organization').find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        toastr.success('Organization has been saved.', 'Success');

        $('#add-organization').modal('hide');
        location.reload();
      }
    }, 'json');
  });

  $('#groups-list').delegate('.btn-edit', 'click', function (e) {
    const btn = $(this);
    const id = btn.data('id');

    btn.button('loading');
    $.post(urlLoadEdit, {
      id
    }, (data, b) => {
      btn.button('reset');

      $('#add-organization  label.control-label').remove();
      $('#add-organization  div.form-group').removeClass('has-error');

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        $('#add-organization #addOrganizationBtn').data('id', id);

        $.each(data, (index, value) => {
          if (index == 'denomination' || index == 'state' || index == 'country' || index == 'is-active') {
            $(`#form-organization .select-${index}`).val(value).trigger('change');
          } else {
            $('#add-organization .form-organization').find(`[name="${index}"]`).val(value);
          }
        });

        const country = $('#form-organization .select-country').val();
        changeState('#form-organization', country);

        $('#add-organization').modal('show');
      }
    });

    e.preventDefault();
  });

  $('.category').on('save', function(e, params) {
    const podcastCheckboxContainer = $(this).parent().parent().find('.podcast-checkbox-container');

    if (params.response.forcePodcast) {
      podcastCheckboxContainer.addClass('force-podcast');
    } else {
      podcastCheckboxContainer.removeClass('force-podcast');
    }
  });

  $('.addOrganization').on('click', () => {
    $('#add-organization #addOrganizationBtn').data('id', '');
    $('#add-organization .form-organization').trigger('reset');
    $('#add-organization  label.control-label').remove();
    $('#add-organization  div.form-group').removeClass('has-error');
    $('#form-organization .select-state, #form-organization .select-country, #form-organization .select-denomination').val('').trigger('change');
  });

  $('#groups-list').delegate('.btn-remove', 'click', function (e) {
    const btn = $(this);
    const id = btn.data('id');
    btn.button('loading');

    bootbox.confirm({
      title: 'Remove from group',
      message: 'Are you sure this organization should be removed from group?',
      buttons: {
        cancel: {
          label: '<i class="fa fa-times"></i> No',
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: '<i class="fa fa-check"></i> Yes',
          className: 'btn-green btn btn-space'
        }
      },
      callback(result) {
        if (result) {
          $.post(urlRemoveOrganizationGroup, {
            id
          }, (data, b) => {
            btn.button('reset');

            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success('Organization has been removed from group.', 'Success');
              location.reload();
            }
          });
        } else {
          btn.button('reset');
        }
      }
    });

    e.preventDefault();
  });

  $('#accountDetail').submit(function (e) {
    const $btn = $(this).find('button').button('loading');

    $('#accountDetail label.control-label').remove();
    $('#accountDetail div.form-group').removeClass('has-error');

    const updateForm = $(this);
    const dataArr = $(this).serializeArray();

    $.post(updateUrl, { dataArr }, (data) => {
      $btn.button('reset');

      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else if (data.formErrorMessagess.length !== 0) {
        $.each(data.formErrorMessagess, (elementId, value) => {
          $.each(value, (index, value) => {
            updateForm.find(`input[name="${elementId}"]`).parent().addClass('has-error');
            updateForm.find(`input[name="${elementId}"]`).after(`<label style="display:block;" for="${elementId}" generated="true" class="control-label">${value}</label>`);
          });
        });

        toastr.error('Form has errors', 'Error');
      } else {
        toastr.success('Organization Profile has been successfully updated', 'Success');
      }
    });

    e.preventDefault();
  });

  $('#updatePassword').submit(function (e) {
    const $btn = $(this).find('button').button('loading');

    $('#updatePassword label.control-label').remove();
    $('#updatePassword div.form-group').removeClass('has-error');

    const updateForm = $(this);
    const dataArr = $(this).serializeArray();

    $.post(updatePasswordUrl, { dataArr }, (data) => {
      $btn.button('reset');

      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else if (data.formErrorMessagess.length !== 0) {
        $.each(data.formErrorMessagess, (elementId, value) => {
          $.each(value, (index, value) => {
            updateForm.find(`input[name="${elementId}"]`).parent().addClass('has-error');
            updateForm.find(`input[name="${elementId}"]`).after(`<label style="display:block;" for="${elementId}" generated="true" class="control-label">${value}</label>`);
          });
        });

        toastr.error('Form has errors', 'Error');
      } else {
        updateForm.find('input[name="password"]').val('');
        updateForm.find('input[name="re-password"]').val('');
        toastr.success('Account has been successfully updated', 'Success');
      }
    });

    e.preventDefault();
  });

  $('#updateServices').submit(function (e) {
    const $btn = $(this).find('button').button('loading');

    $('#updateServices label.control-label').remove();
    $('#updateServices div.form-group').removeClass('has-error');

    const updateForm = $(this);
    const dataArr = $(this).serializeArray();

    $.post(updateServicesUrl, { dataArr }, (data) => {
      $btn.button('reset');

      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else if (data.formErrorMessagess.length !== 0) {
        $.each(data.formErrorMessagess, (elementId, value) => {
          $.each(value, (index, value) => {
            updateForm.find(`input[name="${elementId}"]`).parent().addClass('has-error');
            updateForm.find(`input[name="${elementId}"]`).after(`<label style="display:block;" for="${elementId}" generated="true" class="control-label">${value}</label>`);
          });
        });

        toastr.error('Form has errors', 'Error');
      } else {
        updateForm.find('input[name="password"]').val('');
        updateForm.find('input[name="re-password"]').val('');
        // alert('Services have been successfully updated');

        toastr.success('Services have been successfully updated', 'Success');
      }
    });

    e.preventDefault();
  });

  $('#defaultHymnals').submit(function (e) {
    const $btn = $(this).find('button').button('loading');

    $('#defaultHymnals label.control-label').remove();
    $('#defaultHymnals div.form-group').removeClass('has-error');

    const hymnalsForm = $(this);
    const dataArr = $(this).serializeArray();

    $.post(updateHymnalsUrl, { dataArr }, (data) => {
      $btn.button('reset');

      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        toastr.success('Hymnals have been successfully updated', 'Success');
      }
    });

    e.preventDefault();
  });

  $('.billingSwitch').click(function (e) {
    const label = $(this);
    const checkbox = label.parent().find('input');
    const idUser = checkbox.attr('id').split('-')[1];

    label.hide();
    label.parent().find('img').show();

    $.post(switchBillingUrl, {
      idUser
    }, (data, b) => {
      label.show();
      label.parent().find('img').hide();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else if (data.checked) {
        checkbox.attr('checked', true);
        checkbox.parent().parent().find('.invite').hide();
      } else {
        checkbox.attr('checked', false);
        checkbox.parent().parent().find('.invite').show();
      }
    });
  });

  $('.newsletterSwitch').click(function (e) {
    const label = $(this);
    const checkbox = label.parent().find('input');
    const idUser = checkbox.attr('id').split('-')[1];

    label.hide();
    label.parent().find('img').show();

    $.post(switchNewsletterUrl, {
      idUser
    }, (data, b) => {
      label.show();
      label.parent().find('img').hide();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else if (data.checked) {
        checkbox.attr('checked', true);
      } else {
        checkbox.attr('checked', false);
      }
    });
  });

  $('button.edit').click(function (e) {
    const btn = $(this);
    const idUser = btn.data('id-user');

    btn.button('loading');

    $.post(loadEditUserUrl, {
      idUser
    }, (data, b) => {
      btn.button('reset');

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        $('#updateUserBtn').data('id-user', idUser);
        $('#editUser .modal-body').html(data.html);
        $('#editUser').modal('show');
      }
    });
  });

  $('#updateUserBtn').click(function () {
    $('#editUser .modal-footer button').hide();
    $('#editUser .modal-footer img').show();

    $('.help-block').remove();
    $('#editUser .form-group').removeClass('has-error');

    const idUser = $(this).data('id-user');
    const updateForm = $('#editUser #userForm');
    const dataArr = updateForm.serializeArray();

    $.post(editUserUrl, {
      idUser,
      dataArr,
      isGroup: 0
    }, (data, b) => {
      $('#editUser .modal-footer button').show();
      $('#editUser .modal-footer img').hide();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');

        if (data.formErrorMessagess && data.formErrorMessagess.length !== 0) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              updateForm.find(`[name="${elementId}"]`).parent().addClass('has-error');
              updateForm.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        $(`#email-${idUser}`).html(data.email);
        $(`#name-${idUser}`).html(data.fullname);
        $('#editUser').modal('hide');
        toastr.success('User has been updated.', 'Success');
      }
    }, 'json');
  });

  $('#addUserBtn').click(() => {
    $('#addUser .modal-footer button').hide();
    $('#addUser .modal-footer img').show();

    $('.help-block').remove();
    $('#addUser div').removeClass('has-error');

    const addForm = $('#userAddForm');
    const dataArr = addForm.serializeArray();

    $.post(addUserUrl, {
      dataArr
    }, (data, b) => {
      $('#addUser .modal-footer button').show();
      $('#addUser .modal-footer img').hide();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');

        if (data.formErrorMessagess && data.formErrorMessagess.length !== 0) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              addForm.find(`[name="${elementId}"]`).parent().addClass('has-error');
              addForm.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        $('#addUser').modal('hide');
        toastr.success('User has been added.', 'Success');
        location.reload();
      }
    }, 'json');
  });

  $('button.invite').click(function (e) {
    const btn = $(this);
    const idUser = btn.data('id-user');

    btn.button('loading');
    bootbox.confirm({
      title: 'Send invitation',
      message: 'Do you want to send invitation to selected user?',
      buttons: {
        cancel: {
          label: '<i class="fa fa-times"></i> Cancel',
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: '<i class="fa fa-check"></i> Send Invitation',
          className: 'btn-green btn btn-space'
        }
      },
      callback(result) {
        if (result) {
          $.post(sendInvitationUrl, {
            idUser
          }, (data, b) => {
            btn.button('reset');

            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success('Invitation has been sent.', 'Success');
            }
          });
        } else {
          btn.button('reset');
        }
      }
    });
  });

  $('.send-packet').click(function () {
    const data = $(this).data('number');
    const btn = $(this);

    bootbox.confirm({
      title: 'Send Welcome Packet',
      message: 'Do you want to send Welcome Packet to all users?',
      buttons: {
        cancel: {
          label: '<i class="fa fa-times"></i> Cancel',
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: '<i class="fa fa-check"></i> Send',
          className: 'btn-danger btn btn-space'
        }
      },
      callback(result) {
        if (result) {
          btn.button('loading');

          $.post(sendWelcomePacketUrl, {
            data
          }, (data, b) => {
            btn.button('reset');

            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success(`Welcome email successfully sent to ${data.emails.join(', ')}`, 'Success');
            }
          });
        }
      }
    });
  });

  $('button.delete').click(function (e) {
    const btn = $(this);
    const idUser = btn.data('id-user');
    btn.button('loading');

    bootbox.confirm({
      title: 'Delete user',
      message: 'Do you want to delete selected user? This cannot be undone.',
      buttons: {
        cancel: {
          label: '<i class="fa fa-times"></i> Cancel',
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: '<i class="fa fa-check"></i> Delete',
          className: 'btn-danger btn btn-space'
        }
      },
      callback(result) {
        if (result) {
          $.post(deleteUserUrl, {
            idUser,
            isGroup: 0
          }, (data, b) => {
            btn.button('reset');
            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              btn.parent().parent().fadeOut(300, function () {
                $(this).remove();
                toastr.success('User has been deleted.', 'Success');
              });
            }
          });
        } else {
          btn.button('reset');
        }
      }
    });

    e.preventDefault();
  });

  $('#submit-podcast').click(() => {
    bootbox.confirm({
      title: 'Podcast confirmation',
      message: 'Are you sure to add podcast to your license?',
      buttons: {
        confirm: {
          label: 'Yes',
          className: 'btn-success'
        },
        cancel: {
          label: 'No',
          className: 'btn-danger'
        }
      },
      callback(result) {
        if (result) {
          $('#submit-podcast').button('loading');

          const id = $('#submit-podcast').data('id-invoice');

          $.post(addPodcastUrl, {
            id
          }, (data, b) => {
            if (data.isError == 1) {
              $('#submit-podcast').button('reset');

              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success('License has been successfully upgraded to Podcast', 'Success');

              location.reload();
            }
          });
        }
      }
    });
  });

  $('a#edit-organization-users-btn').click(function (e) {
    const btn = $(this);
    const id = btn.data('id');
    btn.button('loading');

    loadOrganizationUsers(id, (data) => {
      btn.button('reset');
      $('#editGroupUser').data('id', id);
      $('#editGroupUser').modal('show');
    });

    e.preventDefault();
  });

  $('#editGroupUser .select-user').change(function (e) {
    const id = $(this).val();
    const submiButton = $('#editGroupUser #updateUserBtn');
    const remvoeButton = $('#editGroupUser #removeUserBtn');
    const addNewButton = $('#editGroupUser #addUserBtn');
    const userForm = $('#editGroupUser .modal-body .user-form');

    if (id === '0') {
      addNewButton.attr('disabled', true);
      remvoeButton.attr('disabled', true);
    } else {
      addNewButton.attr('disabled', false);
      remvoeButton.attr('disabled', false);
    }

    if (id) {
      submiButton.attr('disabled', false);
      loadEditUserFormData($(this).val());
    } else {
      userForm.html('');
    }
  });

  $('#editGroupUser #updateUserBtn').click(function () {
    $('#editGroupUser .modal-footer button').hide();
    $('#editGroupUser .modal-footer img').show();

    $('.help-block').remove();
    $('#editGroupUser .form-group').removeClass('has-error');

    const userSelectBox = $('#editGroupUser .select-user');
    const idUser = $(this).data('id-user');
    const updateForm = $('#editGroupUser #userForm');
    const addForm = $('#editGroupUser #userAddForm');
    const form = addForm.length ? addForm : updateForm;
    const dataArr = form.serializeArray();

    $.post(editUserUrl, {
      idUser,
      dataArr,
      isGroup: 1
    }, (data, b) => {
      $('#editGroupUser .modal-footer button').show();
      $('#editGroupUser .modal-footer img').hide();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');

        if (data.formErrorMessagess && data.formErrorMessagess.length !== 0) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              form.find(`[name="${elementId}"]`).parent().addClass('has-error');
              form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        $(`#email-${idUser}`).html(data.email);
        $(`#name-${idUser}`).html(data.fullname);
        $(`#owner-${idUser}`).html((data.owner == 1 ? 'YES' : 'NO'));
        $(`#verified-${idUser}`).html((data.verified == 1 ? 'YES' : 'NO'));
        $(`#newsletter-${idUser}`).html((data.newsletter == 1 ? 'YES' : 'NO'));
        $(`#billing-${idUser}`).html((data.billing == 1 ? 'YES' : 'NO'));

        if (data.user) {
          userSelectBox.append($('<option></option>')
              .attr('value', data.user.id)
              .text(`${data.user.name} (${data.user.email})`));

          userSelectBox.find('option[value="0"]').remove();
          userSelectBox.val(data.user.id).change();

          toastr.success('User has been added.', 'Success');
        } else {
          const userOption = userSelectBox.find(`option[value=${idUser}]`);
          userOption.html(`${data.fullname} (${data.email})`);

          toastr.success('User has been updated.', 'Success');
        }

        userSelectBox.select2('destroy').select2({
          placeholder: 'Select User',
          width: '100%',
          minimumResultsForSearch: -1
        });
      }
    }, 'json');
  });

  $('#editGroupUser #removeUserBtn').click(function (e) {
    const btn = $(this);
    const idUser = btn.data('id-user');
    const idOrganization = $('#editGroupUser').data('id');
    const loader = $('#editGroupUser .modal-body .gif-loader');
    const formContainer = $('#editGroupUser .form-container');
    const buttons = $('#editGroupUser .modal-footer .btn');
    buttons.attr('disabled', true);

    bootbox.confirm({
      title: 'Delete user',
      message: 'Do you want to delete selected user? This cannot be undone.',
      buttons: {
        cancel: {
          label: '<i class="fa fa-times"></i> Cancel',
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: '<i class="fa fa-check"></i> Delete',
          className: 'btn-danger btn btn-space'
        }
      },
      callback(result) {
        buttons.button('reset');
        if (result) {
          btn.button('loading');
          formContainer.hide();
          loader.show();

          $.post(deleteUserUrl, {
            idUser,
            isGroup: 1
          }, (data, b) => {
            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              loadOrganizationUsers(idOrganization, (data) => {
                toastr.success('User has been deleted.', 'Success');
                loader.hide();
                btn.button('reset');
                if (data.users.length) formContainer.show();
              });
            }
          });
        }
      }
    });

    e.preventDefault();
  });

  $('#editGroupUser #addUserBtn').click((e) => {
    const userSelectBox = $('#editGroupUser .select-user');
    const newUser = userSelectBox.find('option[value=0]');
    const formContainer = $('#editGroupUser .form-container');
    const info = $('#editGroupUser .info');

    if (!newUser.length) userSelectBox.append($('<option></option>')
        .attr('value', 0)
        .text('New User'));

    userSelectBox.val(0).change();

    info.hide();
    formContainer.show();

    e.preventDefault();
  });

  function makeAccoutOwnerButtonEvent() {
    $('#editGroupUser #makeUserAccountOwner').click(function () {
      const btn = $(this);

      btn.button('loading');
      $.post(makeUserAccountOwnerUrl, {
        organizationUserId: btn.data('id-user')
      }, (data) => {
        btn.button('reset');

        if (data.isError === 1) {
          toastr.error(data.msgError, 'Error');
        } else {
          toastr.success('User has been updated.', 'Success');
          btn.parent().parent().remove();
          $('#editGroupUser #user-billing').parent().parent().remove();
        }
      }, 'json');
    });
  }

  $('#groups-list').delegate('.podcast-checkbox input', 'click', function (e) {
    const input = $(this);
    const checkbox = input.parent().find('label');
    const loading = input.parent().find('.gif-loader');
    const idOrganization = input.data('id');
    const allOrganizationCheckboxes = $(`#groups-list .podcast-checkbox input[data-id="${idOrganization}"]`);

    checkbox.hide();
    loading.show();

    $.post(setRenewalCategoryPodcastUrl, {
      idOrganization,
      isPodcast: input.prop('checked') ? 1 : 0
    }, (data) => {
      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        const isPodcast = data.isPodcast === '1';

        allOrganizationCheckboxes.prop('checked', isPodcast);

        if (isPodcast) {
          toastr.success('Succesfuly added podcast to renewal license category');
        } else {
          toastr.warning('Succesfuly removed podcast from renewal license category');
        }
      }

      checkbox.show();
      loading.hide();
    });

    e.preventDefault();
  });

  function inviteButtonEvent() {
    $('#editGroupUser #sendInvite').click(function (e) {
      const btn = $(this);
      const idUser = btn.data('id-user');

      bootbox.confirm({
        title: 'Send invitation',
        message: 'Do you want to send invitation to selected user?',
        className: 'site-modal',
        buttons: {
          cancel: {
            label: '<i class="fa fa-times"></i> Cancel',
            className: 'btn-default btn-dark'
          },
          confirm: {
            label: '<i class="fa fa-check"></i> Send Invitation',
            className: 'submit-form-button btn btn-green btn-thick'
          }
        },
        callback(result) {
          if (result) {
            btn.button('loading');

            $.post(sendInvitationUrl, {
              idUser,
              isGroup: 1
            }, (data, b) => {
              btn.button('reset');

              if (data.isError == 1) {
                toastr.error(data.msgError, 'Error');
              } else {
                toastr.success('Invitation has been sent.', 'Success');
              }
            });
          }
        }
      });
    });
  }

  function loadEditUserFormData(idUser) {
    const loader = $('#editGroupUser .modal-body .gif-loader');
    const userForm = $('#editGroupUser .modal-body .user-form');
    const idOrganization = $('#editGroupUser').data('id');

    loader.show();
    userForm.hide();
    $.post(loadEditUserInGroupUrl, {
      idUser,
      idOrganization
    }, (data, b) => {
      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        $('#editGroupUser #updateUserBtn').data('id-user', idUser);
        $('#editGroupUser #removeUserBtn').data('id-user', idUser);
        userForm.html(data.html);

        userForm.find('#newsletter').attr('id', 'user-newsletter');
        userForm.find('label[for="newsletter"]').attr('for', 'user-newsletter');

        userForm.find('#billing').attr('id', 'user-billing');
        userForm.find('label[for="billing"]').attr('for', 'user-billing');

        makeAccoutOwnerButtonEvent();
        inviteButtonEvent();
        userForm.show();
        loader.hide();
      }
    });
  }

  function loadOrganizationUsers(idOrganization, callback) {
    const userSelectBox = $('#editGroupUser .select-user');
    const submiButton = $('#editGroupUser #updateUserBtn');
    const removeButton = $('#editGroupUser #removeUserBtn');
    const formContainer = $('#editGroupUser .form-container');
    const info = $('#editGroupUser .info');


    submiButton.attr('disabled', true);
    formContainer.hide();
    info.hide();

    $.post(loadOrganizationUsersUrl, {
      id: idOrganization
    }, (data) => {
      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        userSelectBox.html('');
        if (data.users.length) {
          formContainer.show();
          removeButton.show();
          data.users.forEach((user) => {
            userSelectBox.append($('<option></option>')
                .attr('value', user.id)
                .text(`${user.name} (${user.email})`));
          });

          userSelectBox.val(data.users[0].id).change();
        } else {
          removeButton.hide();
          info.show();
          userSelectBox.val(null).change();
        }

        callback(data);
      }
    });
  }

  function changeState(form, country) {
    const selectedOption = $(`${form} select[name=country]`).find('option:selected');
    const stateDropdown = $(`${form} select[name=state]`);
    const stateText = $(`${form} input[name=stateInput]`);

    if (selectedOption.attr('data-states-count') > 0) {
      if (stateDropdown.is(':visible')) {
        stateDropdown.prop('disabled', true);
      } else if (stateText.is(':visible')) {
        stateText.prop('disabled', true);
      }
      $('.state-loader').show();

      $.get(`${getStatesByCountryUrl}/${selectedOption.attr('value')}`, {

      }, (data) => {
        if (data.isError === 1) {
          toastr.error(data.msgError, 'Error');
        } else {
          stateDropdown.prop('disabled', false);
          $('.state-loader').hide();
          stateText.closest('.form-group').hide();
          stateText.val('');
          const currentState = stateDropdown.val();

          stateDropdown.find('option').remove();
          $.each(data.states, (i, item) => {
            const attr = {
              value: item.code,
              text: item.name
            };
            if (item.code === currentState) {
              attr.selected = 'selected';
            }
            stateDropdown.append($('<option>', attr));
          });
          stateDropdown.closest('.form-group').show();
          stateDropdown.select2({
            placeholder: 'Select State',
            sorter(data) {
              return data.sort((a, b) => {
                if (a.text > b.text) {
                  return 1;
                }
                if (a.text < b.text) {
                  return -1;
                }
                return 0;
              });
            }
          });
        }
      }, 'json');
    } else {
      stateText.prop('disabled', false);
      $('.state-loader').hide();
      stateText.closest('.form-group').show();
      stateDropdown.val('');
      stateDropdown.closest('.form-group').hide();
    }

    const navAccount = $('#navbar-account');
    navAccount.on('click', 'a', null, () => {
      if (window.matchMedia('(max-width: 767px)').matches) navAccount.collapse('hide');
    });
  }

  $('.btn-license-history').click(function (e) {
    $(this).addClass('loader');
  });

  $('.view-invoice a').click(function (e) {
    $(this).closest('.dropdown').hide();
    $(this).closest('.col-sm-6').find('img').show();
    $(this).closest('.col-sm-6').find('.unpaid-invoice-indicator').hide();
  });

  $('.unpaid-invoice-indicator').click(function (e) {
    $(this).closest('.col-sm-6').find('.dropdown').hide();
    $(this).closest('.col-sm-6').find('img').show();
    $(this).hide();
  });

  $('#print-group-report-btn').click(() => {
    $.get(urlGroupReport, (data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        menuController.activateTab('downloads');
      }
    }, 'json');
  });

  $('a#print-year-report-btn').click(function (e) {
    e.preventDefault();
    const organizationId = $(this).data('id');

    $.get(`${urlYearReport}/${organizationId}`, (data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        menuController.activateTab('downloads');
      }
    }, 'json');
  });

  menuController.el.on('tab-activated', (el, tab) => {
    if (tab === 'downloads') {
      reportTable.ajax.reload(null, false);
    }
  });
});
